import { lazy, Suspense, useEffect, useRef } from "react";
import { useTestContext } from "../context/TestContext";
import { useAuthContext } from "../context/AuthContext";

// Imports
import UIWrapper from "../components/UIWrapper";
import Searchbar from "../components/Searchbar";
import WhyChoose from "../components/WhyChoose";
import ProductTypeSelector from "../components/ProductTypeSelector";
import RecommendedLabs from "../components/RecommendedLabs";
import PersonalisedTests from "../components/PersonalisedTests";
import PopularPackages from "../components/PopularPackages";
import ProductComponent from "../components/ProductComponent";
import PackageProductComponent from "../components/PackageProductComponent";
import Testimonial from "../components/Testimonial";
import TrustedBy from "../components/TrustedBy";
import RadiologyProducts from "../components/RadiologyProducts";
import ProductFilter from "../components/ProductFilter";
import LocationCard from "../components/LocationCard";
import DiagnosticTests from "../components/DiagnosticTests";
import { baseUrl } from "../utils/OtherUtils";
import axios from "axios";
import TitleText from "../components/TitleText";

const brancNameFilter = [
	"Redcliffe labs",
	"Agilus Diagnostics",
	"Pathkind Labs",
	"Metropolis Healthcare",
];

const Home = () => {
	const {
		selectedProductType,
		fetchProducts,
		//allProducts,
		fetchProductsByCategories,
		//categoryProducts,
		fetchRadiologyProducts,
		//radiologyProducts,
		fetchPopularProducts,
		popularProducts,
		setProductsToBeSearched,
	} = useTestContext();

	const { userLocationAddress } = useAuthContext();

	// Scroll to top with smooth behavior when data changes (or on initial mount)
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	const contentRef = useRef(null);

	useEffect(() => {
		// Only run this effect when selectedProductType changes
		if (selectedProductType) {
			// Check if screen is smaller than lg breakpoint
			const isSmallScreen = window.innerWidth < 1024; // Typical lg breakpoint is 1024px

			if (isSmallScreen) {
				if (selectedProductType === "Home") {
					// Scroll to the top of the page for Home
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				} else if (contentRef.current) {
					// Calculate position to scroll to (a bit above the element)
					const elementPosition =
						contentRef.current.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - 80; // 80px offset

					// Scroll to the offset position
					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth",
					});
				}
			}
		}
	}, [selectedProductType]);

	useEffect(() => {
		setProductsToBeSearched([]);
		fetchProducts();
		fetchRadiologyProducts(1);
		fetchProductsByCategories(1);
		fetchPopularProducts();
	}, []);

	const sortedPopulatProducts = popularProducts.sort((a, b) => {
		if (!a.brandName) return 1; // Push undefined to the end
		if (!b.brandName) return -1;
		if (
			a.brandName === "Agilus Diagnostics" &&
			b.brandName !== "Agilus Diagnostics"
		) {
			return -1;
		}
		if (
			b.brandName === "Agilus Diagnostics" &&
			a.brandName !== "Agilus Diagnostics"
		) {
			return 1; // Move other brands below
		}
		return a.brandName.localeCompare(b.brandName); // Sort alphabetically if neither is the target
	});

	// const handleAddDrLalProducts = async () => {
	// 	console.log("Adding Dr Lal products...");
	// 	  try {
	//     const response = await axios.get(`${baseUrl}/api/products/add-drlal-products`);
	//     console.log("Success:", response.data);
	// 	} catch (error) {
	// 		console.error("Error adding Dr Lal products:", error);
	// 	}
	// }

	// const handleDeleteDrLalProducts = async () => {
	// 	  console.log("Deleting Dr Lal products...");
	// 	try {
	// 	const response = await axios.delete(`${baseUrl}/api/products/delete-drlal-products`);
	// 	console.log("Success:", response.data);
	// 	} catch (error) {
	// 	console.error("Error deleting Dr Lal products:", error);
	// 	}
	// }

	// const handleUpdatePathKindLabsProducts = async () => {
	// 	console.log("Updating PathKind Labs products...");
	// 	try {
	// 		const response = await axios.get(`${baseUrl}/api/products/update-pathkind-products`);
	// 		console.log("Success:", response.data);
	// 	} catch (error) {
	// 		console.error("Error updating PathKind Labs products:", error);
	// 	}
	// }

	// const handleAddServiceableArea = async () => {
	// 	console.log("Adding serviceable areas...");
	// 	try {
	// 		const response = await axios.get(`${baseUrl}/api/orders/add-serviceable-areas`);
	// 		console.log("Success:", response.data);
	// 	} catch (error) {
	// 		console.error("Error adding serviceable areas:", error);
	// 	}
	// };

	// const handleAddCentres = async () => {
	// 	console.log("Adding centres...");
	// 	try {
	// 		const response = await axios.get(`${baseUrl}/api/centre/add-centres`);
	// 		console.log("Success:", response.data);
	// 	} catch (error) {
	// 		console.error("Error adding serviceable areas:", error);
	// 	}
	// };

	// const updateParametersRedcliffe = async () => {
	// 	try {
	// 		console.log("Updating Redcliffe Labs parameters...");
	// 		const response = await axios.get(`${baseUrl}/api/products/update-parameters-redcliffe-products`);
	// 		console.log("Update successful:", response.data);
	// 		return response.data;
	// 	} catch (error) {
	// 		console.error("Error updating parameters:", error.response?.data || error.message);
	// 		throw error;
	// 	}
	// 	};

	// const updateFastingRedcliffe = async () => {
	// try {
	// 	console.log("Updating Redcliffe Labs fasting times...");
	// 	const response = await axios.get(`${baseUrl}/api/products/update-fasting-time-redcliffe`);
	// 	console.log("Fasting time update successful:", response.data);
	// 	return response.data;
	// } catch (error) {
	// 	console.error("Error updating fasting times:", error.response?.data || error.message);
	// 	throw error;
	// }
	// };

	return (
		<UIWrapper>
			<ProductFilter />
			{/* <div className="w-full flex justify-center">
				<div className="p-2 mb-2 rounded-3xl bg-blue-500 text-white cursor-pointer" onClick={updateFastingRedcliffe}>
					Update fasting Redcliffe
				</div>
			</div> */}
			<Searchbar />
			<div className='w-full text-center h-fit px-[5%] lg:px-[10%] py-[5%] lg:py-[2%] '>
				<WhyChoose isScrollable={true} />
			</div>
			<div className='w-full text-center h-fit px-[10%] py-[5%] hidden lg:block lg:py-[2%]'>
				<div className='flex flex-col items-center'>
					<TitleText text='Follow the Simple Steps To' />
					<h1 className='font-semibold mt-2 mb-4 lg:w-fit text-lg text-left text-[20px] sm:text-[22px] lg:text-[24px] text-[#0047AF]'>
						Book Lab Test
					</h1>
					<img
						src='/assets/steps.png'
						alt='follow-step'
						className='lg:h-[597px] lg:w-[616px] w-[120%]'
					/>
				</div>
			</div>
			<div className='w-full text-center h-fit px-[10%] py-[5%] lg:py-[2%] lg:hidden'>
				<RecommendedLabs />
			</div>

			<ProductTypeSelector />

			{selectedProductType === "Home" && (
				<ProductComponent
					title='Most Prescribed Diagnostic Tests'
					filter={brancNameFilter}
					products={popularProducts}
				/>
			)}
			{selectedProductType === "Home" && (
				<PackageProductComponent
					title='Popular Packages'
					filter={brancNameFilter}
					products={popularProducts}
				/>
			)}
			{/* {selectedProductType === "Home" && (
        <ProductComponent
          title="Popular X-Ray"
          filter={brancNameFilter}
          products={radiologyProducts}
        />
      )} */}
			<div ref={contentRef}>
				{selectedProductType !== "Home" &&
					selectedProductType !== "Radiology" && (
						<div className='hidden lg:block'>
							<RecommendedLabs />
						</div>
					)}
				{selectedProductType === "Radiology" && <RadiologyProducts />}
				{selectedProductType === "Test" && <PersonalisedTests />}
				{selectedProductType === "Test" && <DiagnosticTests />}
				{selectedProductType === "Package" && <PopularPackages />}
				{selectedProductType === "Home" && (
					<div className='hidden lg:block'>
						<RecommendedLabs />
					</div>
				)}
				{selectedProductType === "Home" && <PersonalisedTests />}
				<Testimonial />
			</div>
			<div className='w-full text-center h-fit  py-[5%] lg:py-[2%] block lg:hidden'>
				<div className='flex flex-col items-center'>
					<TitleText text='Follow the Simple Steps To' />
					<h1 className='font-semibold mb-4 lg:w-fit text-lg text-left text-[20px] sm:text-[22px] lg:text-[24px] text-[#0047AF]'>
						Book Lab Test
					</h1>
					<img
						src='/assets/steps.png'
						alt='follow-step'
						className='lg:h-[597px] lg:w-[616px] w-[120%]'
					/>
				</div>
			</div>
			<TrustedBy />
		</UIWrapper>
	);
};

export default Home;
